import * as CubeTree from '../../cubeTree/index';
import FrontCubeData from '../../frontCubeData/index';
import { cubeModify } from '../../update/cubeModify';

export function updateFreeLayerInShelfSize(layerId: CubeId): void {
    let parentCubeId: CubeId = CubeTree.findParentIdByCubeId(layerId);
    let layerWidth: PhysicsMeasurement = FrontCubeData.getNumberValue(layerId, 'moduleWidth');

    if (CubeTree.isShelf(parentCubeId) && layerWidth < 0) {
        let shelfWidth: PhysicsMeasurement = FrontCubeData.getNumberValue(parentCubeId, 'width');

        cubeModify(layerId, {
            moduleWidth: shelfWidth
        });
    }

    if (CubeTree.isFreezer(parentCubeId)) {
        let freezerWidth: PhysicsMeasurement = FrontCubeData.getNumberValue(parentCubeId, 'width');
        let freezerHeight: PhysicsMeasurement = FrontCubeData.getNumberValue(parentCubeId, 'height');
        let freezerDepth: PhysicsMeasurement = FrontCubeData.getNumberValue(parentCubeId, 'depth');

        cubeModify(layerId, {
            moduleWidth: freezerWidth,
            moduleHeight: freezerHeight,
            moduleDepth: freezerDepth
        });
    }
}
